import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";

const IDENTITY_POOL_ID = "ap-south-1:c92ea9dd-7a35-4960-962c-bd5c8fd14f57";
const REGION = "ap-south-1";
const BUCKET = "managemyshaadib";



if (!REGION || !BUCKET || !IDENTITY_POOL_ID) {
  throw new Error("AWS S3 environment variables are not set");
}

const s3Client = new S3Client({
  region: REGION,
  credentials: fromCognitoIdentityPool({
    clientConfig: { region: REGION },
    identityPoolId: IDENTITY_POOL_ID,
  }),
});

export async function uploadFileToS3(file, key) {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const body = new Uint8Array(arrayBuffer); // ✅ fix for TS

    const params = {
      Bucket: BUCKET,
      Key: key,
      Body: body,
      ContentType: file.type,
      ACL: "public-read"
    };

    await s3Client.send(new PutObjectCommand(params));

    return `https://${BUCKET}.s3.${REGION}.amazonaws.com/${key}`;
  } catch (err) {
    console.error("S3 upload error:", err);
    throw new Error("Failed to upload to S3");
  }
}